import { IDeviationPriorityProps } from "pages/deviation/deviation.interface"

export const priorityOptions: Array<{ label: string; value: number }> = [
  { label: "Ingen", value: 0 },
  { label: "Låg", value: 1 },
  { label: "Medel", value: 2 },
  { label: "Hög", value: 3 }
]

export const deviationPriorityProps = (id: number, t?: any) => {
  switch (id) {
    case 0:
      return {
        key: "none",
        title: "None",
        color: "default"
      } as IDeviationPriorityProps
    case 1:
      return {
        key: "low",
        title: "Low",
        color: "primary"
      } as IDeviationPriorityProps
    case 2:
      return {
        key: "medium",
        title: "Medium",
        color: "warning"
      } as IDeviationPriorityProps
    case 3:
      return {
        key: "high",
        title: "High",
        color: "error"
      } as IDeviationPriorityProps
    default:
      return {
        key: "none",
        title: "None",
        color: "default"
      } as IDeviationPriorityProps
  }
}
